<template>
    <create-assistent-modal ref="modal" />
    <button-outline @click="openCreateAssistentModal">
        <flex-container align-items="center" gap="xs">
            <svg-icon
                :icon="AddIcon"
                color="primary"
            />
            <span>Nieuwe website of chatbot</span>
        </flex-container>
    </button-outline>
</template>

<script setup lang="ts">
    import CreateAssistentModal from '@/ai/assistent/components/CreateAssistentModal.vue';
    import { ref } from 'vue';
    import type { ExposedOverlay } from '@keyvue/one-ui';
    import AddIcon from '@keyvue/one-material-icons/icons/add.svg?component';

    const modal = ref<{
        overlay: ExposedOverlay,
    }>();

    function openCreateAssistentModal() {
        modal.value?.overlay.openOverlay();
    }
</script>
